import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import Tooltip from '@/components/Tooltip'
import { showTaxInfoMessageSelector, taxInfoMessageSelector } from '@/selectors'
import { translate } from '@/utils/translations'

import ReduxProvider from '../ReduxProvider'
import SkeletonThemeWrapper from '../SkeletonThemeWrapper'
import Icon from '../Tooltip/Icon'

const classList = [
  'type--cloud10',
  'font-6',
  'u-weight--normal',
  'd-flex',
  'justify-content-center',
  'mb-2',
].join(' ')

const TaxInfoMessage = () => {
  const hasNZTaxRate = useSelector(state => state.asset.hasNZTax)
  const showTaxInfo = useSelector(showTaxInfoMessageSelector)
  const taxInfoMessage = useSelector(taxInfoMessageSelector)

  const [isShowing, setIsShowing] = useState(false)

  useEffect(() => {
    setIsShowing(true)
  })

  return (
    <If condition={showTaxInfo}>
      <Choose>
        <When condition={isShowing}>
          <div className={classList}>
            {' '}{taxInfoMessage}
            <If condition={hasNZTaxRate}>
              <Tooltip tooltipText={translate('tooltips.nz_tax')} >
                <Icon />
              </Tooltip>
            </If>
          </div>
        </When>
        <Otherwise>
          <SkeletonThemeWrapper count={1} />
        </Otherwise>
      </Choose>
    </If>
  )
}

/*eslint-disable react/no-multi-comp*/
const Component = () => (
  <ReduxProvider>
    <TaxInfoMessage />
  </ReduxProvider>
)
export default Component
